import UserStore from './UserStore';
import ProductStore from './ProductStore';
import { createContext, useContext } from 'react';

class RootStore {
    constructor() {
        this.user = new UserStore();
        this.product = new ProductStore();
        // Добавьте другие store по мере необходимости
    }
}

const StoreContext = createContext({ store: new RootStore() });

export const useStore = () => useContext(StoreContext);
export default StoreContext; 